import TableWidgetSeparated from "@modul-connect/shared/components/molecules/tableWidget/tableWidgetSeparated.v2"
import ReportPage from "../reportPage.v2"
import { getVehicleReportColumns, vehicle_report_columns } from "./temperatureReportDetails/log_columns"
import { timespanOptions } from "../datePickers/timespanPickers/timespanPickers"
import { useEffect, useMemo, useState } from "react"
import { DateTime } from "luxon"
import { connect, useDispatch, useSelector } from "react-redux"
import { useAuth0 } from "@auth0/auth0-react"
import { getThermometerLogs, getVehiclesWithTemplate, getVehicleWithTemperatureData } from "../../../state/actions/vehicles"
import { useTranslation } from "react-i18next"
import { BubbleLoadingWidget } from "@modul-connect/shared/components/molecules/bubbleLoadingWidget/bubbleLoadingWIdget"
import { getServiceList } from "../../../utils/ServiceList"
import { ServiceType } from "@modul-connect/shared/utils/services"

const TemperatureReportPageV2 = ({ subtrees, selected_organisations }) => {
  const [startDate, setStartDate] = useState(DateTime.local().startOf('month'))
  const [endDate, setEndDate] = useState(DateTime.local().endOf('month'))

  const dispatch = useDispatch()

  const { getAccessTokenSilently } = useAuth0()

  const {t} = useTranslation()

  const downloading = useSelector(state => state.downloading)

  const vehicleReportColumns = getVehicleReportColumns(t)

  const disabled = !getServiceList({ subtrees }).hasServiceForSelected(selected_organisations, ServiceType.ClimateReports)

  const downloadingRowId =
  downloading?.thermometer_logs?.status === 'working'
    ? downloading.thermometer_logs.id
    : null


  useEffect(() => {
    getAccessTokenSilently()
      .then(accessToken => {
        dispatch(getVehicleWithTemperatureData( 
          accessToken,
          startDate.toUTC(),
          endDate.toUTC()
        )) 
      })
     
  }, [startDate.toMillis(), endDate.toMillis()])
  const downloadThermometerLogs = async (id) => {
    if (!id) return
    await getAccessTokenSilently()
      .then(accessToken => {
        dispatch(getThermometerLogs( 
          accessToken,
          id,
          startDate, 
          endDate,
          15
        )) 
      })
  }

  const vehiclesData = useSelector(state => state.vehicles_data)
  const vehiclesWithTempData = useSelector(state => state.vehicleWithTemperatureData)
  const loading = useSelector(state => state.loading.vehicleWithTemperatureData)

  const vehicleData = useMemo(() => {
    if (vehiclesWithTempData !== undefined && vehiclesData.data.length !== 0)
      return vehiclesData.data
        .filter(v => vehiclesWithTempData.includes(v.mainbox_id))
        .map(v => ({
          id: v.mainbox_id,
          vehicleName: v.vehicleName,
          box: v.mainbox_id,
        }))
    return []
  }, [vehiclesWithTempData])

  const vehicleTable = 
    <TableWidgetSeparated
      data={vehicleData}
      columns={vehicleReportColumns}
      totalItems={vehicleData.length}
      themes={'themes'}
      isSortable
      defaultSort="vehicleName" 
      defaultSortOrder="asc"
      isDownloading={downloadingRowId ? [downloadingRowId] : []}
      onDownload={(_, id) => {
        downloadThermometerLogs(id)
      }}
    />

  return (
    <ReportPage
      disabled={disabled}
      title={t('climateSystem.settings.temperatureLogs')}
      noSearch
      timeSelectors={[
        timespanOptions.year,
        timespanOptions.month,
        timespanOptions.week,
        timespanOptions.day,
        timespanOptions.custom,
      ]}
      startDate={startDate}
      endDate={endDate}
      onTimeframePicked={(start, end) => {
        setStartDate(start)
        setEndDate(end)
      }}
      tables={vehicleTable}
      isLoading={loading === "loading"}
    >
    </ReportPage>
  )
}

const mapStateToProps = props => props

const mapDispatchToProps = () => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(TemperatureReportPageV2)